import React, { useEffect, useState } from "react";
import { collection, doc, setDoc } from "firebase/firestore";
import { auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";
import { Link } from "react-router-dom";

import { database, StorageFolder } from "./firebaseConfig";
import {
  Box,
  Button,
  Center,
  ChakraProvider,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Stack,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbSeparator,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Image,
  useMediaQuery,
  TableContainer,
} from "@chakra-ui/react";
import { getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";

import NavBar from "./NavBar";
import FormMenu from "./FormMenu";
import Logo from "./Logo";
import { useLanguage } from "./languageContext";

const ImageUpload = () => {
  const [selected, setSelected] = useState<any>([]);
  const [imageUrls, setImageUrls] = useState<any>([]);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [isSmallScreen] = useMediaQuery("(max-width: 1100px)");

  const handleFileChange = (event) => {
    const images = event.target.files;
    setSelected([...images]);
  };

  const uploadImage = async (event) => {
    event.preventDefault();
    const uploadPromises = selected.map((image) => {
      const imageName = image.name;
      const imageRef = ref(StorageFolder, `/test-images/${imageName}`);
      return uploadBytes(imageRef, image).then((snapshot) => {
        return getDownloadURL(snapshot.ref);
      });
    });
    Promise.all(uploadPromises).then((urls) => {
      setImageUrls(urls);
    });

    setShowSuccessModal(true);
  };
  const SuccessModal = ({ isOpen, onClose }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {language === "english" ? "Successful" : "Exitoso"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {language === "english"
              ? "Data uploaded successfully!"
              : "¡Datos subidos exitosamente!"}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="teal" onClick={onClose}>
              {language === "english" ? "Exit" : "Salir"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleSignOut = async () => {
    try {
      // Sign out from Firebase authentication
      await signOut(auth);
      // Navigate to the login page
      window.location.href = "/";
    } catch (error) {
      console.log(
        language === "english"
          ? "Error signing out:"
          : "Error al cerrar sesión:",
        error
      );
    }
  };

  const handleAddUser = async () => {
    try {
      window.location.href = "/AddUser";
    } catch (error) {
      console.log(
        language === "english"
          ? "Error Adding User"
          : "Error al agregar usuario",
        error
      );
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (selected) {
      console.log(
        language === "english" ? "Selected File:" : "Archivo Seleccionado:",
        selected
      );

      const reader = new FileReader();
      reader.readAsDataURL(selected);
    }
  };
  const { language, toggleLanguage } = useLanguage();
  return (
    <ChakraProvider>
      <Box
        backgroundImage={"url(bird.jpeg)"}
        backgroundSize="cover"
        // backdropFilter="auto"
        // backdropBlur={"5px"}
      >
        <NavBar />

        <VStack spacing={4} align="stretch">
          <Center>
            <Stack align="center">
              <Box
                p={4}
                pt={"10%"}
                width={{ base: "100%", md: "100%" }}
                maxW="1100px"
                minH="100vh"
              >
                <Box p={8} bg="white" rounded="md" shadow="md" width="100%">
                  <SuccessModal
                    isOpen={showSuccessModal}
                    onClose={() => setShowSuccessModal(false)}
                  />

                  <FormMenu isSmallScreen={isSmallScreen} />
                  <Logo isSmallScreen={isSmallScreen} />
                  <Box textAlign="center">
                    <Heading fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}>
                      {language === "english" ? "Image Upload" : "Subir imagen"}
                    </Heading>
                  </Box>

                  <form onSubmit={handleSubmit}>
                    <FormControl marginBottom="20px">
                      <FormLabel>
                        {" "}
                        {language === "english"
                          ? "Select Image"
                          : "Seleccionar imagen"}{" "}
                      </FormLabel>
                      <Input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        required
                        multiple
                      />
                    </FormControl>
                    <FormControl id="date" marginBottom="20px">
                      <FormLabel>
                        {" "}
                        {language === "english" ? "Date" : "Fecha"}{" "}
                      </FormLabel>
                      <Input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required
                      />
                    </FormControl>
                    <Stack
                      direction={{ base: "column", md: "row" }}
                      spacing="24px"
                      align="center"
                    >
                      {selected && (
                        <Button
                          onClick={uploadImage}
                          colorScheme="green"
                          mt={4}
                        >
                          {language === "english"
                            ? "Submit Image"
                            : "Enviar Imagen"}
                        </Button>
                      )}
                    </Stack>
                  </form>
                </Box>
              </Box>
            </Stack>
          </Center>
        </VStack>
      </Box>
    </ChakraProvider>
  );
};

export default ImageUpload;
